import { withStyles } from '@material-ui/core';
import { Base } from 'components';
import Progress from 'components/Progress';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import TodayBox from './components/TodayBox';
import styles from './homeStyles';

const mapStateToProps = ({ home, loading }) => {
    return ({
        fetching: loading.effects.home.fetchHome,
        items: home.items,
    });
};

const mapDispatch = (dispatch) => ({ fetchHome: () => dispatch.home.fetchHome() });

const reduxConnector = connect(mapStateToProps, mapDispatch);

class Home extends Component {
    componentDidMount() {
        const { fetchHome } = this.props;

        fetchHome();
    }

    render() {
        const { items, classes, fetching } = this.props;


        if (fetching || !items) {
            return <Progress />;
        }

        return (
            <>
                <Base>
                    <TodayBox items={items} />

                </Base>
            </>
        );
    }
}

export default compose(withStyles(styles, { name: 'Home' }), reduxConnector)(Home);
